import React, { useState } from 'react';
import { Controller } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwipeTwo from 'swiper';
import { BsStarFill, BsStarHalf } from 'react-icons/bs';
import '../assets/style/customSwiperFour.scss';
import firdavs from '../assets/images/testimonials/Firdavs-Allamurotov.png';
import ridwan from '../assets/images/testimonials/Ridwan-Diallo.png';
import ranjit from '../assets/images/testimonials/Ranjit-Luwang.png';

const Testimonials = () => {
  const [controlledSwiper1, setControlledSwiper1] = useState(() => new SwipeTwo('.triple-slider .slider-prev', {}));
  const [controlledSwiper2, setControlledSwiper2] = useState(() => new SwipeTwo('.triple-slider .slider-next', {}));
  const [controlledSwiperCenter, setControlledSwiperCenter] = useState(null);

  if (!controlledSwiper1 || !controlledSwiper2) {
    return <div>Loading...</div>;
  }

  const handlePrevClick = () => {
    if (controlledSwiperCenter) {
      controlledSwiperCenter.slidePrev();
    }
  };

  const handleNextClick = () => {
    if (controlledSwiperCenter) {
      controlledSwiperCenter.slideNext();
    }
  };

  return (
    <div className="triple-slider">
      <Swiper
        modules={[Controller]}
        onSwiper={setControlledSwiper1}
        allowTouchMove={false}
        onClick={handlePrevClick}
        className="slider-prev"
        loop
        wrapperClass="prev-card-overflow"
      >
        <SwiperSlide className="card">
          <img className="avatar" src={ranjit} alt="Ranjit Luwang" />
          <svg className="quote-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="125px" height="125px">
            <path
              d="M 16.482422 8.9921875 A 1.50015 1.50015 0 0 0 15.943359 9.1074219 C 15.943359 9.1074219 13.068414 10.279429 10.357422 13.464844 C 7.6464301 16.650259 5 21.927419 5 30 A 1.50015 1.50015 0 0 0 5.015625 30.21875 A 8.5 8.5 0 0 0 13.5 39 A 8.5 8.5 0 0 0 13.5 22 A 8.5 8.5 0 0 0 8.7089844 23.480469 C 9.5777265 19.777157 11.122152 17.196657 12.642578 15.410156 C 14.931586 12.720571 17.056641 11.892578 17.056641 11.892578 A 1.50015 1.50015 0 0 0 16.482422 8.9921875 z M 37.482422 8.9921875 A 1.50015 1.50015 0 0 0 36.943359 9.1074219 C 36.943359 9.1074219 34.068414 10.279429 31.357422 13.464844 C 28.64643 16.650259 26 21.927419 26 30 A 1.50015 1.50015 0 0 0 26.015625 30.21875 A 8.5 8.5 0 0 0 34.5 39 A 8.5 8.5 0 0 0 34.5 22 A 8.5 8.5 0 0 0 29.708984 23.480469 C 30.577727 19.777157 32.122152 17.196657 33.642578 15.410156 C 35.931586 12.720571 38.056641 11.892578 38.056641 11.892578 A 1.50015 1.50015 0 0 0 37.482422 8.9921875 z"
            />
          </svg>
          <div className="senk">
            <div className="header">
              <h1 className="name">Mayengbam Ranjit Luwang </h1>
              <h2 className="title">Full-Stack Developer, Online-Trader & Architect</h2>
            </div>
            <div className="quote-container">
              <p className="quote">
                <span className="quote-span">
                  Said and I have done pair programming together. He is quite knowledgeable
                  and amazed me with his fast tackling of problems. It was nice to collaborate
                  with him to solve problems and looking forward to again collaborating.
                </span>
              </p>
              <div className="quote-stars">
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarHalf className="star-val" />
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="card">
          <img className="avatar" src={firdavs} alt="Firdavs Allamurotov" />
          <svg className="quote-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="125px" height="125px">
            <path
              d="M 16.482422 8.9921875 A 1.50015 1.50015 0 0 0 15.943359 9.1074219 C 15.943359 9.1074219 13.068414 10.279429 10.357422 13.464844 C 7.6464301 16.650259 5 21.927419 5 30 A 1.50015 1.50015 0 0 0 5.015625 30.21875 A 8.5 8.5 0 0 0 13.5 39 A 8.5 8.5 0 0 0 13.5 22 A 8.5 8.5 0 0 0 8.7089844 23.480469 C 9.5777265 19.777157 11.122152 17.196657 12.642578 15.410156 C 14.931586 12.720571 17.056641 11.892578 17.056641 11.892578 A 1.50015 1.50015 0 0 0 16.482422 8.9921875 z M 37.482422 8.9921875 A 1.50015 1.50015 0 0 0 36.943359 9.1074219 C 36.943359 9.1074219 34.068414 10.279429 31.357422 13.464844 C 28.64643 16.650259 26 21.927419 26 30 A 1.50015 1.50015 0 0 0 26.015625 30.21875 A 8.5 8.5 0 0 0 34.5 39 A 8.5 8.5 0 0 0 34.5 22 A 8.5 8.5 0 0 0 29.708984 23.480469 C 30.577727 19.777157 32.122152 17.196657 33.642578 15.410156 C 35.931586 12.720571 38.056641 11.892578 38.056641 11.892578 A 1.50015 1.50015 0 0 0 37.482422 8.9921875 z"
            />
          </svg>
          <div className="senk">
            <div className="header">
              <h1 className="name">Firdavs Allamurotov</h1>
              <h2 className="title">Full-Stack Developer, StrategyConnect Inc</h2>
            </div>
            <div className="quote-container">
              <p className="quote">
                <span className="quote-span">
                  I have no doubt that Said Rasinlic is on the path to a successful career
                  in software development. I wholeheartedly recommend him to any prospective
                  employer who is looking for a talented and adaptable Fullstack developer.
                  His dedication to learning, his strong technical skills, and his
                  exceptional soft skills make him an asset to any organization.
                </span>
              </p>
              <div className="quote-stars">
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarHalf className="star-val" />
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="card">
          <img className="avatar" src={ridwan} alt="Ridwan Diallo" />
          <svg className="quote-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="125px" height="125px">
            <path
              d="M 16.482422 8.9921875 A 1.50015 1.50015 0 0 0 15.943359 9.1074219 C 15.943359 9.1074219 13.068414 10.279429 10.357422 13.464844 C 7.6464301 16.650259 5 21.927419 5 30 A 1.50015 1.50015 0 0 0 5.015625 30.21875 A 8.5 8.5 0 0 0 13.5 39 A 8.5 8.5 0 0 0 13.5 22 A 8.5 8.5 0 0 0 8.7089844 23.480469 C 9.5777265 19.777157 11.122152 17.196657 12.642578 15.410156 C 14.931586 12.720571 17.056641 11.892578 17.056641 11.892578 A 1.50015 1.50015 0 0 0 16.482422 8.9921875 z M 37.482422 8.9921875 A 1.50015 1.50015 0 0 0 36.943359 9.1074219 C 36.943359 9.1074219 34.068414 10.279429 31.357422 13.464844 C 28.64643 16.650259 26 21.927419 26 30 A 1.50015 1.50015 0 0 0 26.015625 30.21875 A 8.5 8.5 0 0 0 34.5 39 A 8.5 8.5 0 0 0 34.5 22 A 8.5 8.5 0 0 0 29.708984 23.480469 C 30.577727 19.777157 32.122152 17.196657 33.642578 15.410156 C 35.931586 12.720571 38.056641 11.892578 38.056641 11.892578 A 1.50015 1.50015 0 0 0 37.482422 8.9921875 z"
            />
          </svg>
          <div className="senk">
            <div className="header">
              <h1 className="name">Ridwan Diallo</h1>
              <h2 className="title">Full-Stack Develper, Freelance</h2>
            </div>
            <div className="quote-container">
              <p className="quote">
                <span className="quote-span">
                  Said is a hardworking student who adapts well to new situations. Throughout our
                  Microverse studies, we have worked numerous times. We have collaborated on
                  several projects and worked in pairs. He is a quick learner who is well-versed
                  in Web Development and problem-solving. He conducts himself professionally
                  and knows how to communicate effectively. He would be an important member
                  of any team due to his industry-standard skills.
                  I wholeheartedly recommend him to you.
                </span>
              </p>
              <div className="quote-stars">
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarHalf className="star-val" />
              </div>
            </div>
          </div>

        </SwiperSlide>
      </Swiper>
      <Swiper
        modules={[Controller]}
        controller={{ control: [controlledSwiper1, controlledSwiper2] }}
        onSwiper={setControlledSwiperCenter}
        className="slider-center"
        loop
      >
        <SwiperSlide className="card">
          <img className="avatar" src={firdavs} alt="Firdavs Allamurotov" />
          <svg className="quote-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="125px" height="125px">
            <path
              d="M 16.482422 8.9921875 A 1.50015 1.50015 0 0 0 15.943359 9.1074219 C 15.943359 9.1074219 13.068414 10.279429 10.357422 13.464844 C 7.6464301 16.650259 5 21.927419 5 30 A 1.50015 1.50015 0 0 0 5.015625 30.21875 A 8.5 8.5 0 0 0 13.5 39 A 8.5 8.5 0 0 0 13.5 22 A 8.5 8.5 0 0 0 8.7089844 23.480469 C 9.5777265 19.777157 11.122152 17.196657 12.642578 15.410156 C 14.931586 12.720571 17.056641 11.892578 17.056641 11.892578 A 1.50015 1.50015 0 0 0 16.482422 8.9921875 z M 37.482422 8.9921875 A 1.50015 1.50015 0 0 0 36.943359 9.1074219 C 36.943359 9.1074219 34.068414 10.279429 31.357422 13.464844 C 28.64643 16.650259 26 21.927419 26 30 A 1.50015 1.50015 0 0 0 26.015625 30.21875 A 8.5 8.5 0 0 0 34.5 39 A 8.5 8.5 0 0 0 34.5 22 A 8.5 8.5 0 0 0 29.708984 23.480469 C 30.577727 19.777157 32.122152 17.196657 33.642578 15.410156 C 35.931586 12.720571 38.056641 11.892578 38.056641 11.892578 A 1.50015 1.50015 0 0 0 37.482422 8.9921875 z"
            />
          </svg>
          <div className="senk">
            <div className="header">
              <h1 className="name">Firdavs Allamurotov</h1>
              <h2 className="title">Full-Stack Developer, StrategyConnect Inc</h2>
            </div>
            <div className="quote-container">
              <p className="quote">
                <span className="quote-span">
                  I have no doubt that Said Rasinlic is on the path to a successful career
                  in software development. I wholeheartedly recommend him to any prospective
                  employer who is looking for a talented and adaptable Fullstack developer.
                  His dedication to learning, his strong technical skills, and his
                  exceptional soft skills make him an asset to any organization.
                </span>
              </p>
              <div className="quote-stars">
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarHalf className="star-val" />
              </div>
            </div>

          </div>
        </SwiperSlide>

        <SwiperSlide className="card">
          <img className="avatar" src={ridwan} alt="Ridwan Diallo" />
          <svg className="quote-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="125px" height="125px">
            <path
              d="M 16.482422 8.9921875 A 1.50015 1.50015 0 0 0 15.943359 9.1074219 C 15.943359 9.1074219 13.068414 10.279429 10.357422 13.464844 C 7.6464301 16.650259 5 21.927419 5 30 A 1.50015 1.50015 0 0 0 5.015625 30.21875 A 8.5 8.5 0 0 0 13.5 39 A 8.5 8.5 0 0 0 13.5 22 A 8.5 8.5 0 0 0 8.7089844 23.480469 C 9.5777265 19.777157 11.122152 17.196657 12.642578 15.410156 C 14.931586 12.720571 17.056641 11.892578 17.056641 11.892578 A 1.50015 1.50015 0 0 0 16.482422 8.9921875 z M 37.482422 8.9921875 A 1.50015 1.50015 0 0 0 36.943359 9.1074219 C 36.943359 9.1074219 34.068414 10.279429 31.357422 13.464844 C 28.64643 16.650259 26 21.927419 26 30 A 1.50015 1.50015 0 0 0 26.015625 30.21875 A 8.5 8.5 0 0 0 34.5 39 A 8.5 8.5 0 0 0 34.5 22 A 8.5 8.5 0 0 0 29.708984 23.480469 C 30.577727 19.777157 32.122152 17.196657 33.642578 15.410156 C 35.931586 12.720571 38.056641 11.892578 38.056641 11.892578 A 1.50015 1.50015 0 0 0 37.482422 8.9921875 z"
            />
          </svg>
          <div className="senk">
            <div className="header">
              <h1 className="name">Ridwan Diallo</h1>
              <h2 className="title">Full-Stack Develper, Freelance</h2>
            </div>
            <div className="quote-container">
              <p className="quote">
                <span className="quote-span">
                  Said is a hardworking student who adapts well to new situations. Throughout our
                  Microverse studies, we have worked numerous times. We have collaborated on
                  several projects and worked in pairs. He is a quick learner who is well-versed
                  in Web Development and problem-solving. He conducts himself professionally
                  and knows how to communicate effectively. He would be an important member
                  of any team due to his industry-standard skills.
                  I wholeheartedly recommend him to you.
                </span>
              </p>
              <div className="quote-stars">
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarHalf className="star-val" />
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="card">
          <img className="avatar" src={ranjit} alt="Ranjit Luwang" />
          <svg className="quote-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="125px" height="125px">
            <path
              d="M 16.482422 8.9921875 A 1.50015 1.50015 0 0 0 15.943359 9.1074219 C 15.943359 9.1074219 13.068414 10.279429 10.357422 13.464844 C 7.6464301 16.650259 5 21.927419 5 30 A 1.50015 1.50015 0 0 0 5.015625 30.21875 A 8.5 8.5 0 0 0 13.5 39 A 8.5 8.5 0 0 0 13.5 22 A 8.5 8.5 0 0 0 8.7089844 23.480469 C 9.5777265 19.777157 11.122152 17.196657 12.642578 15.410156 C 14.931586 12.720571 17.056641 11.892578 17.056641 11.892578 A 1.50015 1.50015 0 0 0 16.482422 8.9921875 z M 37.482422 8.9921875 A 1.50015 1.50015 0 0 0 36.943359 9.1074219 C 36.943359 9.1074219 34.068414 10.279429 31.357422 13.464844 C 28.64643 16.650259 26 21.927419 26 30 A 1.50015 1.50015 0 0 0 26.015625 30.21875 A 8.5 8.5 0 0 0 34.5 39 A 8.5 8.5 0 0 0 34.5 22 A 8.5 8.5 0 0 0 29.708984 23.480469 C 30.577727 19.777157 32.122152 17.196657 33.642578 15.410156 C 35.931586 12.720571 38.056641 11.892578 38.056641 11.892578 A 1.50015 1.50015 0 0 0 37.482422 8.9921875 z"
            />
          </svg>
          <div className="senk">
            <div className="header">
              <h1 className="name">Mayengbam Ranjit Luwang </h1>
              <h2 className="title">Full-Stack Developer, Online-Trader & Architect</h2>
            </div>
            <div className="quote-container">
              <p className="quote">
                <span className="quote-span">
                  Said and I have done pair programming together. He is quite knowledgeable
                  and amazed me with his fast tackling of problems. It was nice to collaborate
                  with him to solve problems and looking forward to again collaborating.
                </span>
              </p>
              <div className="quote-stars">
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarHalf className="star-val" />
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      <Swiper
        modules={[Controller]}
        onSwiper={setControlledSwiper2}
        allowTouchMove={false}
        onClick={handleNextClick}
        className="slider-next"
        loop
        wrapperClass="next-card-overflow"
      >
        <SwiperSlide className="card">
          <img className="avatar" src={ridwan} alt="Ridwan Diallo" />
          <svg className="quote-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="125px" height="125px">
            <path
              d="M 16.482422 8.9921875 A 1.50015 1.50015 0 0 0 15.943359 9.1074219 C 15.943359 9.1074219 13.068414 10.279429 10.357422 13.464844 C 7.6464301 16.650259 5 21.927419 5 30 A 1.50015 1.50015 0 0 0 5.015625 30.21875 A 8.5 8.5 0 0 0 13.5 39 A 8.5 8.5 0 0 0 13.5 22 A 8.5 8.5 0 0 0 8.7089844 23.480469 C 9.5777265 19.777157 11.122152 17.196657 12.642578 15.410156 C 14.931586 12.720571 17.056641 11.892578 17.056641 11.892578 A 1.50015 1.50015 0 0 0 16.482422 8.9921875 z M 37.482422 8.9921875 A 1.50015 1.50015 0 0 0 36.943359 9.1074219 C 36.943359 9.1074219 34.068414 10.279429 31.357422 13.464844 C 28.64643 16.650259 26 21.927419 26 30 A 1.50015 1.50015 0 0 0 26.015625 30.21875 A 8.5 8.5 0 0 0 34.5 39 A 8.5 8.5 0 0 0 34.5 22 A 8.5 8.5 0 0 0 29.708984 23.480469 C 30.577727 19.777157 32.122152 17.196657 33.642578 15.410156 C 35.931586 12.720571 38.056641 11.892578 38.056641 11.892578 A 1.50015 1.50015 0 0 0 37.482422 8.9921875 z"
            />
          </svg>
          <div className="senk">
            <div className="header">
              <h1 className="name">Ridwan Diallo</h1>
              <h2 className="title">Full-Stack Develper, Freelance</h2>
            </div>
            <div className="quote-container">
              <p className="quote">
                <span className="quote-span">
                  Said is a hardworking student who adapts well to new situations. Throughout our
                  Microverse studies, we have worked numerous times. We have collaborated on
                  several projects and worked in pairs. He is a quick learner who is well-versed
                  in Web Development and problem-solving. He conducts himself professionally
                  and knows how to communicate effectively. He would be an important member
                  of any team due to his industry-standard skills.
                  I wholeheartedly recommend him to you.
                </span>
              </p>
              <div className="quote-stars">
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarHalf className="star-val" />
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="card">
          <img className="avatar" src={ranjit} alt="Ranjit Luwang" />
          <svg className="quote-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="125px" height="125px">
            <path
              d="M 16.482422 8.9921875 A 1.50015 1.50015 0 0 0 15.943359 9.1074219 C 15.943359 9.1074219 13.068414 10.279429 10.357422 13.464844 C 7.6464301 16.650259 5 21.927419 5 30 A 1.50015 1.50015 0 0 0 5.015625 30.21875 A 8.5 8.5 0 0 0 13.5 39 A 8.5 8.5 0 0 0 13.5 22 A 8.5 8.5 0 0 0 8.7089844 23.480469 C 9.5777265 19.777157 11.122152 17.196657 12.642578 15.410156 C 14.931586 12.720571 17.056641 11.892578 17.056641 11.892578 A 1.50015 1.50015 0 0 0 16.482422 8.9921875 z M 37.482422 8.9921875 A 1.50015 1.50015 0 0 0 36.943359 9.1074219 C 36.943359 9.1074219 34.068414 10.279429 31.357422 13.464844 C 28.64643 16.650259 26 21.927419 26 30 A 1.50015 1.50015 0 0 0 26.015625 30.21875 A 8.5 8.5 0 0 0 34.5 39 A 8.5 8.5 0 0 0 34.5 22 A 8.5 8.5 0 0 0 29.708984 23.480469 C 30.577727 19.777157 32.122152 17.196657 33.642578 15.410156 C 35.931586 12.720571 38.056641 11.892578 38.056641 11.892578 A 1.50015 1.50015 0 0 0 37.482422 8.9921875 z"
            />
          </svg>
          <div className="senk">
            <div className="header">
              <h1 className="name">Mayengbam Ranjit Luwang </h1>
              <h2 className="title">Full-Stack Developer, Online-Trader & Architect</h2>
            </div>
            <div className="quote-container">
              <p className="quote">
                <span className="quote-span">
                  Said and I have done pair programming together. He is quite knowledgeable
                  and amazed me with his fast tackling of problems. It was nice to collaborate
                  with him to solve problems and looking forward to again collaborating.
                </span>
              </p>
              <div className="quote-stars">
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarHalf className="star-val" />
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="card">
          <img className="avatar" src={firdavs} alt="Firdavs Allamurotov" />
          <svg className="quote-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="125px" height="125px">
            <path
              d="M 16.482422 8.9921875 A 1.50015 1.50015 0 0 0 15.943359 9.1074219 C 15.943359 9.1074219 13.068414 10.279429 10.357422 13.464844 C 7.6464301 16.650259 5 21.927419 5 30 A 1.50015 1.50015 0 0 0 5.015625 30.21875 A 8.5 8.5 0 0 0 13.5 39 A 8.5 8.5 0 0 0 13.5 22 A 8.5 8.5 0 0 0 8.7089844 23.480469 C 9.5777265 19.777157 11.122152 17.196657 12.642578 15.410156 C 14.931586 12.720571 17.056641 11.892578 17.056641 11.892578 A 1.50015 1.50015 0 0 0 16.482422 8.9921875 z M 37.482422 8.9921875 A 1.50015 1.50015 0 0 0 36.943359 9.1074219 C 36.943359 9.1074219 34.068414 10.279429 31.357422 13.464844 C 28.64643 16.650259 26 21.927419 26 30 A 1.50015 1.50015 0 0 0 26.015625 30.21875 A 8.5 8.5 0 0 0 34.5 39 A 8.5 8.5 0 0 0 34.5 22 A 8.5 8.5 0 0 0 29.708984 23.480469 C 30.577727 19.777157 32.122152 17.196657 33.642578 15.410156 C 35.931586 12.720571 38.056641 11.892578 38.056641 11.892578 A 1.50015 1.50015 0 0 0 37.482422 8.9921875 z"
            />
          </svg>
          <div className="senk">
            <div className="header">
              <h1 className="name">Firdavs Allamurotov</h1>
              <h2 className="title">Full-Stack Developer, StrategyConnect Inc</h2>
            </div>
            <div className="quote-container">
              <p className="quote">
                <span className="quote-span">
                  I have no doubt that Said Rasinlic is on the path to a successful career
                  in software development. I wholeheartedly recommend him to any prospective
                  employer who is looking for a talented and adaptable Fullstack developer.
                  His dedication to learning, his strong technical skills, and his
                  exceptional soft skills make him an asset to any organization.
                </span>
              </p>
              <div className="quote-stars">
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarFill className="star-val" />
                <BsStarHalf className="star-val" />
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Testimonials;
